import React from "react";
import CreatorDetails from "../../../pages/ChangeRequest/activities/creatorDetails";
import { ucFirst } from "../../../helpers/string_helper";
import { Action } from "../../../constants/Common";
import { withTranslation } from "react-i18next";
function Contact({ item, t }) {
  return (
    <div>
      <div>
        <strong>
          {" "}
          Contact ({ucFirst(item?.payload?.firstName)} {ucFirst(item?.payload?.lastName)}) {" "}
        </strong>
         {item.event === Action.CREATE ? t("was added to") : item.event === Action.UPDATE ? t("was updated for") : t("was deleted from")}{" "}
        <strong>
          {t('startup')} {ucFirst(item.project?.name)} (
          {item?.project?.uniqueProjectId})
        </strong>{" "}
        {t('by')}
        <CreatorDetails creator={item?.creator} date={item?.createdAt} />
      </div>
    </div>
  );
}
export default withTranslation()(Contact);